import { Component, Input } from '@angular/core';

export type TAvatarSize = 'xs' | 'sm' | 'lg';

/**
 * A student's initials on the colour of their level, used wherever a student is listed: the roster,
 * the detail header and both calendar views.
 *
 * The colour comes from the `.level-<key>` classes in shared/styles, which expose `--level-primary`;
 * which level is passed in is the caller's decision, because it differs per exam (`level_id` for the
 * base exam, `secondary_level_id` for the proficiency one).
 */
@Component({
  selector: 'coach-student-avatar',
  templateUrl: './student-avatar.component.html',
  styleUrl: './student-avatar.component.scss',
})
export class StudentAvatarComponent {
  @Input() name?: string | null;
  /** ELevelKey of the level that colours the avatar; falls back to the neutral palette. */
  @Input() levelKey?: string | null;
  /** xs: 24px calendar cards · sm: 40px lists · lg: 56px detail header. */
  @Input() size: TAvatarSize = 'sm';

  initials(): string {
    if (!this.name) {
      return '?';
    }

    return this.name.trim().split(' ').filter(Boolean).slice(0, 2)
      .map(part => part[0]).join('').toLocaleUpperCase('tr-TR');
  }
}
